export const safeJoin = (items: (string | null | undefined)[], separator?: string) => {
    return items.filter(Boolean).join(separator);
};

/** Levenshtein edit distance between two strings. */
export function levenshtein(a: string, b: string): number {
    if (a === b) {
        return 0;
    }
    if (a.length === 0) {
        return b.length;
    }
    if (b.length === 0) {
        return a.length;
    }

    let prev: number[] = Array.from({ length: b.length + 1 }, (_, k) => k);

    let i = 0;
    for (const ca of a) {
        const curr: number[] = [i + 1];
        let j = 0;
        for (const cb of b) {
            const deletion = (prev[j + 1] ?? 0) + 1;
            const insertion = (curr[j] ?? 0) + 1;
            const substitution = (prev[j] ?? 0) + (ca === cb ? 0 : 1);
            curr.push(Math.min(deletion, insertion, substitution));
            j++;
        }
        prev = curr;
        i++;
    }
    return prev[b.length] ?? 0;
}

export function tryParseNumberStrict(text: string): number | undefined {
    const trimmed = text.trim();
    if (/^[0-9]+([.,][0-9]*)?$/.test(trimmed)) {
        return Number.parseFloat(trimmed);
    }
}

export function tryParseURL(text: string, defaultProtocol?: string): URL | undefined {
    const trimmed = text.trim();
    try {
        return new URL(trimmed);
    } catch {
        if (defaultProtocol) {
            return tryParseURL(defaultProtocol + trimmed);
        }
    }
}
